module.exports = __webpack_public_path__ + "static/media/house.3f1ed730.jpeg";